var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiNimby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emojiNimby") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.52 4.301c6.286 0 11.399 5.252 11.399 11.706s-5.114 11.706-11.399 11.706c-2.134 0-4.216-0.612-6.022-1.767l-5.239 1.429 1.46-5.388c-1.047-1.803-1.6-3.872-1.6-5.98 0-6.454 5.114-11.706 11.399-11.706zM15.518 0.132c-8.54 0-15.46 7.107-15.46 15.875 0 2.966 0.794 5.74 2.173 8.115l-1.9 7.204 7.016-1.844c2.37 1.52 5.17 2.4 8.171 2.4 8.54 0 15.46-7.107 15.46-15.875s-6.919-15.875-15.459-15.875h-0.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.93 18.571c1.398 0 2.532-1.223 2.532-2.731s-1.134-2.731-2.532-2.731c-1.398 0-2.532 1.223-2.532 2.731s1.134 2.731 2.532 2.731z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 18.571c1.398 0 2.532-1.223 2.532-2.731s-1.134-2.731-2.532-2.731c-1.398 0-2.532 1.223-2.532 2.731s1.134 2.731 2.532 2.731z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.911 23.22c-2.14-0.032-4.156-0.231-6.264-0.065-0.967 0.073-1.836 0.218-2.861 0.394 2.175-2.484 6.688-2.327 9.124-0.329h0.002z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.396 13.605c0 0 1.561 0.087 3.087-0.428s2.437-1.438 2.437-1.438c0 0-1.561-0.087-3.087 0.428s-2.437 1.438-2.437 1.438z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.249 13.598c0 0-1.561 0.087-3.086-0.428s-2.437-1.438-2.437-1.438c0 0 1.561-0.087 3.087 0.428s2.437 1.438 2.437 1.438z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiNimby);
export default __webpack_public_path__ + "static/media/emojiNimby.b199de1a361ab8668fbb5943bdf7a93b.svg";
export { ForwardRef as ReactComponent };